<template>
    <div v-if="summaryVisible" class="col-lg-12 px-0 js-water-payment-summary mb-5">
        <div class="d-flex flex-wrap justify-content-between mb-3">
            <h4 class="mt-0">
                {{ summary.vat == 0 ? model.summaryHeadingBusiness : model.summaryHeadingHome }}
            </h4>
            <year-select :label="model.yearSelectLabel"
                         :years="model.years"
                         :next="model.nextYearLabel"
                         :prev="model.prevYearLabel"
                         :current-year="selectedYear"
                         @change-year="changeYear" />
        </div>

        <table v-if="summary.monthlyTotalServiceFee > 0" class="summary-table summary-table-water-payment" role="complementary" aria-label="model.summaryHeadingBase">
            <thead>
                <tr>
                    <th id="noheading" scope="col">
                        {{ model.baseChargeLabel }}
                    </th>
                    <th id="vatmonth" scope="col">
                        €/{{ model.monthLabel }} ({{ model.vatTotalLabel}} {{ toPercentage(summary.vat) }})
                    </th>
                    <th id="vatyear" scope="col">
                        €/{{ model.yearLabel }} ({{ model.vatTotalLabel}} {{ toPercentage(summary.vat) }})
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-if="summary.monthlyWaterServiceFee > 0">
                    <td>
                        {{ model.waterBaseChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlyWaterServiceFee) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualWaterServiceFee) }}
                    </td>
                </tr>
                <tr v-if="summary.monthlySewerServiceFee > 0">
                    <td>
                        {{ model.sewerBaseChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlySewerServiceFee) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualSewerServiceFee) }}
                    </td>
                </tr>
                <tr v-if="summary.monthlyStormdrainServiceFee > 0">
                    <td>
                        {{ model.drainageWellBaseChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlyStormdrainServiceFee) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualStormdrainServiceFee) }}
                    </td>
                </tr>
                <tr>
                    <td>
                        {{ model.totalBaseChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlyTotalServiceFee) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualTotalServiceFee) }}
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="spacer"></div>

        <table class="summary-table summary-table-water-payment" role="complementary" :aria-label="model.summaryHeadingUsage">
            <thead>
                <tr>
                    <th id="noheading" scope="col">
                        {{ model.usageChargeLabel }}
                    </th>
                    <th id="vatmonth" scope="col">
                        €/{{ model.monthLabel }} ({{ model.vatTotalLabel}} {{ toPercentage(summary.vat) }})
                    </th>
                    <th id="vatyear" scope="col">
                        €/{{ model.yearLabel }} ({{ model.vatTotalLabel}} {{ toPercentage(summary.vat) }})
                    </th>
                </tr>
            </thead>
            <tbody>

                <tr v-if="summary.monthlyWaterUsageFeeTotalValue > 0 || summary.annualWaterUsageFeeTotalValue > 0">
                    <td>
                        {{ model.waterUsageChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlyWaterUsageFeeTotalValue) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualWaterUsageFeeTotalValue) }}
                    </td>
                </tr>

                <tr v-if="summary.monthlyWasteUsageFeeTotalValue > 0 || summary.annualWasteUsageFeeTotalValue > 0">
                    <td>
                        {{ model.sewerUsageChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlyWasteUsageFeeTotalValue) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualWasteUsageFeeTotalValue) }}
                    </td>
                </tr>

                <tr>
                    <td>
                        {{ model.totalUsageChargeLabel }}
                    </td>
                    <td>
                        {{ toCurrency(summary.monthlyFeeTotalValue) }}
                    </td>
                    <td>
                        {{ toCurrency(summary.annualFeeTotalValue) }}
                    </td>
                </tr>

            </tbody>
        </table>

        <div class="h5 summary-total">
                {{ model.totalChargeLabel }} {{ selectedYear }} ({{ model.vatTotalLabel}} {{ toPercentage(summary.vat) }}) {{ toCurrency(summary.annualFeeFinalTotalValue) }}
        </div>

    </div>
</template>

<script>
    import YearSelect from './year-select.vue';
    import { mapState } from 'vuex'
    export default {
        components: {
            'year-select': YearSelect,
        },
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        computed: mapState({
            summaryVisible: state => state.waterPaymentStore.summaryVisible,
            selectedYear: state => state.waterPaymentStore.selectedYear,
            summary: state => state.waterPaymentStore.summary
        }),
        methods: {
            toCurrency: function (value) {
              if (typeof value !== "number") {
                return value;
              }
              var formatter = new Intl.NumberFormat('fi', {
                style: 'currency',
                currency: 'EUR'
              });
              return formatter.format(value);
            },
            toPercentage: function (value) {
              if (typeof value !== "number") {
                return value;
              }
              const percentageValue = value.toString().replace(".", ",");
              return `${percentageValue} %`;
            },
            changeYear(year) {
                this.$store.commit("waterPaymentStore/setSelectedYear", year);
            }
        }
    }
</script>